// Date helpers shared by the desktop tables. Dates are compared as yyyymmdd
// numbers, which sort correctly and need no timezone handling.

export { formatYmd } from "./caseFilters";

export const todayYmd = () => {
  const now = new Date();
  return now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
};

const toYmd = (year, month, day) => {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!y || m < 1 || m > 12 || d < 1 || d > 31) return null;
  return y * 10000 + m * 100 + d;
};

// Finds the first date in a string written as dd/mm/yyyy, dd.mm.yyyy,
// dd-mm-yyyy, yyyy/mm/dd or yyyy-mm-dd (the case types store different
// formats). Returns a yyyymmdd number, or null.
export const parseLooseYmd = (value) => {
  if (!value) return null;
  const text = String(value);
  const ymdFirst = text.match(/(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})/);
  if (ymdFirst) return toYmd(ymdFirst[1], ymdFirst[2], ymdFirst[3]);
  const dmyFirst = text.match(/(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})/);
  if (dmyFirst) return toYmd(dmyFirst[3], dmyFirst[2], dmyFirst[1]);
  return null;
};

// True when ymd is today or within the next `days` days.
export const isUpcoming = (ymd, days = Infinity) => {
  if (!ymd) return false;
  const today = todayYmd();
  if (ymd < today) return false;
  if (days === Infinity) return true;
  const limit = new Date();
  limit.setDate(limit.getDate() + days);
  const limitYmd =
    limit.getFullYear() * 10000 + (limit.getMonth() + 1) * 100 + limit.getDate();
  return ymd <= limitYmd;
};
